module.exports = __webpack_public_path__ + "resources/img/pc_banner4_v3.4730d0555ff2df13ddfa5e7b23ea5b17.png";